import { render, staticRenderFns } from "./orderNew.vue?vue&type=template&id=6cb459ec&"
import script from "./orderNew.vue?vue&type=script&lang=js&"
export * from "./orderNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports